const getters = {
  sidebar: state => state.app.sidebar,
  routerlist: state => state.user.routerlist,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  // massage: state => state.user.massage,

  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles, // 角色
  location: state => state.user.location,
  locationCode: state => state.user.locationCode, // 三级联动需要的
  tokenuserName: state => state.user.userName,
  usermassage: state => state.user.usermassage,
  permission_routes: state => state.permission.routes,
  addRoutes: state => state.permission.addRoutes,

  show: state => false,

  errorLogs: state => state.errorLog.logs,

  form: state => state.logoTitle.form,
  protoImg: state => state.logoTitle.protoImg,
  userName: state => state.logoTitle.userName,

  paths: state => state.permission.paths,

  buildData: state => state.building.buildingData,

  urgencyShow: state => state.urgency.urgencyShow,
  urgencyPopShow: state => state.urgency.urgencyPopShow,

  // 本地权限角色
  archAdd: state => state.role.archAdd,
  CheckBut: state => state.role.CheckBut,
  CheckButTwo: state => state.role.CheckButTwo,
  DelWb: state => state.role.DelWb,
  Admin: state => state.role.Admin,
  usersel: state => state.role.usersel,
  customer: state => state.role.customer,
  government: state => state.role.government,
  Tertiary: state => state.role.Tertiary,
  building: state => state.role.building,
  Route: state => state.role.Route,
  Patrol: state => state.role.Patrol,
  maintenance: state => state.role.maintenance
}
export default getters
